import { createStyles, makeStyles } from "@material-ui/core";
import {
    Button,
    CircleIcon,
    DesktopPage,
    DesktopPageActions,
    DesktopPageSection,
    DesktopSideBar,
    DesktopSideBarPane,
    DesktopTabbedContent,
    RelodeTheme,
    StatusLabel,
    Text,
} from "@relode/core";
import { JobCandidateStatus, Routing } from "@relode/core/domain";
import * as React from "react";

import {
    CandidateHighlights,
    CandidateResumeDesktop,
    InterviewAvailability,
    JobManagerContactDetails,
} from "../../../../shared/components/candidate";
import {
    useClientPublicCandidateContext,
} from "../_infra/clientPublicCandidateProvider";

const useStyles = makeStyles(
    (theme: RelodeTheme) =>
        createStyles({
            circle: {
                fontSize: "0.5em",
                color: theme.palette.action.active,
                marginTop: theme.spacing(1),
                marginRight: theme.spacing(1),
                marginLeft: theme.spacing(1),
            },
            forLabel: {
                color: theme.palette.grey[500],
            },
        }),
    { name: "CandidateDetailsDesktop" }
);

export const ClientPublicCandidateDetailsDesktop = () => {
    const {
        state: {
            data: { candidate },
            ui: { isCandidateLoading },
        },
    } = useClientPublicCandidateContext();
    const classes = useStyles({});

    const status = candidate.highlights
        ? JobCandidateStatus.fromId(candidate.highlights.candidateStatusId)
        : undefined;
    const privateUrl = `/client/candidates/${candidate.job.jobId}/${candidate.highlights.leadId}`;

    if (candidate.redirectToPrivate) window.location.href = privateUrl;

    const giveFeedback = () => {
        localStorage.setItem("relode:redirectUrl", privateUrl);
        window.location.href = Routing.Account.SIGNIN + "?appName=client";
    };

    return (
        <DesktopPage
            pageTitle={candidate.highlights.fullName}
            isBusy={isCandidateLoading}
            actions={
                <DesktopPageActions
                    showLogo={true}
                    title={
                        candidate.highlights
                            ? candidate.highlights.fullName
                            : "n/a"
                    }
                    statusLabel={
                        status ? (
                            <StatusLabel
                                title={status.description}
                                jobCandidateStatus={status}
                            />
                        ) : null
                    }
                    subtitle={
                        <Text>
                            <span className={classes.forLabel}>for:</span>{" "}
                            {candidate.job.jobName}{" "}
                            <CircleIcon className={classes.circle} />{" "}
                            {candidate.job.location.locationName}
                        </Text>
                    }
                    giveFeedback={
                        candidate.showGiveFeedback ? (
                            <Button color="primary" onClick={giveFeedback}>
                                give feedback
                            </Button>
                        ) : null
                    }
                />
            }
        >
            <DesktopTabbedContent defaultSection="highlights">
                <DesktopPageSection label="highlights" id="highlights">
                    <CandidateHighlights
                        highlights={candidate.highlights}
                        qualifications={candidate.qualifications}
                        additionalInfo={candidate.additionalInfo}
                    />
                </DesktopPageSection>

                <DesktopPageSection label="resume" id="resume">
                    <CandidateResumeDesktop
                        resume={candidate.formattedResume}
                    />
                </DesktopPageSection>
            </DesktopTabbedContent>

            <DesktopSideBar>
                <DesktopSideBarPane>
                    <InterviewAvailability
                        availability={candidate.availability}
                        additionalInfo={candidate.additionalInfo}
                    />
                </DesktopSideBarPane>

                <DesktopSideBarPane>
                    <JobManagerContactDetails
                        title="questions?"
                        jobManagerContact={candidate.jobManager}
                        contactActionVariant="link"
                        leadId={candidate.highlights.leadId}
                        leadName={candidate.highlights.fullName}
                        jobId={candidate.job.jobId}
                        jobName={candidate.job.jobName}
                    />
                </DesktopSideBarPane>
            </DesktopSideBar>
        </DesktopPage>
    );
};
